'use client';

import LaptopFilters from '@/components/LaptopFilters';
import VgaFilters from '@/components/VgaFilters';
import RamFilters from '@/components/RamFilters';
import SsdFilters from '@/components/SsdFilters';
import HddFilters from '@/components/HddFilters';
import CpuFilters from '@/components/CpuFilters';
import MainboardFilters from '@/components/MainboardFilters';
import CaseFilters from '@/components/CaseFilters';
import KeyboardFilters from '@/components/KeyboardFilters';
import MouseFilters from '@/components/MouseFilters';
import HeadsetFilters from '@/components/HeadsetFilters';
import NetworkingFilters from '@/components/NetworkingFilters';
import PrinterFilters from '@/components/PrinterFilters';
import UpsFilters from '@/components/UpsFilters';
import CameraFilters from '@/components/CameraFilters';
import MonitorFilters from '@/components/MonitorFilters';
import CoolingFilters from '@/components/CoolingFilters';
import PsuFilters from '@/components/PsuFilters';
import WebcamFilters from '@/components/WebcamFilters';
import type { FilterSchemaKey } from '@/lib/catalog/types';

type CatalogFilterSidebarProps = {
  filterSchemaKey: FilterSchemaKey;
};

import PriceFilter from '@/components/catalog/PriceFilter';

export default function CatalogFilterSidebar({ filterSchemaKey }: CatalogFilterSidebarProps) {
  let SpecificFilters = null;

  switch (filterSchemaKey) {
    case 'laptop':
      SpecificFilters = <LaptopFilters />;
      break;
    case 'cpu':
      SpecificFilters = <CpuFilters />;
      break;
    case 'mainboard':
      SpecificFilters = <MainboardFilters />;
      break;
    case 'vga':
      SpecificFilters = <VgaFilters />;
      break;
    case 'case':
      SpecificFilters = <CaseFilters />;
      break;
    case 'ram':
      SpecificFilters = <RamFilters />;
      break;
    case 'ssd':
      SpecificFilters = <SsdFilters />;
      break;
    case 'hdd':
      SpecificFilters = <HddFilters />;
      break;
    case 'keyboard':
      SpecificFilters = <KeyboardFilters />;
      break;
    case 'mouse':
      SpecificFilters = <MouseFilters />;
      break;
    case 'headset':
      SpecificFilters = <HeadsetFilters />;
      break;
    case 'networking':
      SpecificFilters = <NetworkingFilters />;
      break;
    case 'printer':
      SpecificFilters = <PrinterFilters />;
      break;
    case 'ups':
      SpecificFilters = <UpsFilters />;
      break;
    case 'camera':
      SpecificFilters = <CameraFilters />;
      break;
    case 'monitor':
      SpecificFilters = <MonitorFilters />;
      break;
    case 'cooling':
      SpecificFilters = <CoolingFilters />;
      break;
    case 'psu':
      SpecificFilters = <PsuFilters />;
      break;
    case 'webcam':
      SpecificFilters = <WebcamFilters />;
      break;
  }

  return (
    <div className="flex min-h-0 flex-col gap-4">
      <div className="bg-white/50 backdrop-blur-md p-4 rounded-2xl border border-slate-200 shadow-sm flex items-center justify-between">
        <h2 className="font-bold text-slate-800 text-lg flex items-center gap-2">
          <svg
            className="w-5 h-5 text-red-500"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
            />
          </svg>
          Bộ lọc sản phẩm
        </h2>
      </div>
      <PriceFilter />
      {SpecificFilters}
    </div>
  );
}
